import { apiConfig } from "../config/apiConfig";
import { getBrandDetailsFromBrandJson, getFooterLink, getWeblocationPathGroupWithFooterConfig, getWeblocationPathGroupWithSiteConfig, setLocalTagLineText } from "../util/share";
import { apiCaching } from "../config/cachingConfig";
import { cachedAPIWrapper, getCachedAPIResponse } from "../apiCaching/apiWrapper";
import { showAddressForGoogle } from "../util/addressOnLeadFlow";
import { handleSocialIcon } from "../util/getDynamicMenu";
import { FullAttributeParams } from "../apiCaching/GET-Requests/interface/fullattribute/fullattributeInterface";
import apiRequest from "../api/apiRequest";
import { replaceLegalFooter } from "../util/localizationService";
import { shouldSkipPhoneNumberProcessing } from "../util/phoneNumberReplacement";
import { waitForBrandDataBeforeFooterConfig} from "../util/brandLoadingManager";
import { isTestEnvironment } from "../apiCaching/POST-Requests/helperModules/helperFunctions";
import { ConditionalLocalization } from "../nbly-brand/conditional_localization";

type services = {
    link: string,
    name: string
}

type address = {
    locationDoingBusinessAs: string,
    address: string,
    address2: string,
    state: string,
    country: string,
    city: string,
    zip: string,
    displayAddressSwitch: boolean,
    stateLicenseNumbers: any

}
export class Footer {
    constructor(isLocalize: boolean) {
        const dbaName : any = document.getElementById('dbaName');
        if(dbaName){
            localStorage.setItem('dbaName', dbaName?.value);
        }
        if (isLocalize) {
            this.getFooterData();
        } else {
            const phoneNumb = document.querySelector('.fb-des-para > .fb-tel') as HTMLAnchorElement;
            this.setMobileNumber(phoneNumb?.innerText);
        }
        const headerLinks: any = document.querySelectorAll('.dynamic-service-menu')
        if (headerLinks.length > 0) {
            let data: any = []
            headerLinks.forEach((item: any) => {
                data.push({
                    name: item?.querySelector('a span').textContent.trim(),
                    link: item?.querySelector('a').href

                })
            })
            this.setServices(data)
        }else {
            let serviceData:any = getFooterLink();
            this.setServices(serviceData);
        }
        this.setupFooter();
    }

    static async init() {
        let isLocalize = false;
        if (localStorage.getItem('localPhoneNumber') || localStorage.getItem("franchiseWebLocationId") || (document.getElementById('weblocationId') as HTMLInputElement)?.value) {
            isLocalize = true;
        } else {
            handleSocialIcon();
        }

      return new Footer(isLocalize);
    }
    private setupFooter() {
        this.initializeFooter();
    }
    private async initializeFooter() {
        await this.localizeLegalWrapper();
        await this.setYear();
    }

    async localizeLegalWrapper() {
        return this.localizeLegalFooter();
    }

    async setYear() {
        const weblocation_path_group_url: string = await getWeblocationPathGroupWithSiteConfig();
        try{
            if(weblocation_path_group_url){
                const resp = await getCachedAPIResponse(weblocation_path_group_url, apiCaching.SiteConfig, false);
                const { token_details } = resp;
                setLocalTagLineText(resp);
                try {
                    let elementsWithPlaceholder = document.body.querySelectorAll("*");
                    token_details?.forEach((token: any) => {
                        elementsWithPlaceholder.forEach(function (element: any) {
                            let key = token.key;
                            // Use a regular expression to replace placeholders
                            if (element.innerHTML && element.innerHTML.includes(`{${key}}`)) {
                                const regex = new RegExp(`\\{${key}\\}`, 'g');
                                element.innerHTML = element.innerHTML.replace(regex, token.value);
                            }
                        });
                    });
                } catch (error) {
                    throw new Error (error as string);
                }
            }
            
        }
        catch (err){
            console.error("Error in fetching site config and setting footer Year", err);
        }
    }
    
    public async getLocalSocialIcon() {
        if(!ConditionalLocalization.getInstance().init()) return;
        const urlSiteConfig = await getWeblocationPathGroupWithSiteConfig();
        try{
            if(urlSiteConfig){
                const cachedResponse = await getCachedAPIResponse(urlSiteConfig, apiCaching.SiteConfig, false);
                if (cachedResponse) {
                    return cachedResponse.social_links
                }
            }
            
        }
        catch{
            console.error("Error in fetching site config");
            return {}
        }
    }

   
    public getFooterData(): void {
        if(!ConditionalLocalization.getInstance().init()) return;
        try {
            const weblocationId = localStorage.getItem("franchiseWebLocationId") || (document.getElementById('weblocationId') as HTMLInputElement)?.value;
            const request = `${apiConfig.FOOTER_BRAND_LINK}${weblocationId}`;
           cachedAPIWrapper(request)
                .then(async (resp: any) => {
                    this.appendSocialLinks(resp?.franchiseWebLocationLinks);
                    this.changeFooterAddress(resp);
                    await this.fetchCesUrl();
                    let callTrack:any;
                    resp?.callTrackings.forEach((type:any)=>{
                        if(type.callTrackingTypeDescription === "WebsiteTracking"){
                            callTrack = type.callTrackingNumber;
                        }
                    });
                    if(!callTrack){
                        callTrack = resp?.mainPhoneNumber;
                    }
                    this.setMobileNumber(callTrack);
                })
                .catch((error) => {
                    console.error('Error fetching FOOTER_BRAND_LINK:', error);
                });
        } catch (error) {
            console.error('Error fetching FOOTER_BRAND_LINK:', error);
        }
    }
    public formSocialLink(filteredNationalSocialicon: any[]){
        const tempArr: any[] = []
         filteredNationalSocialicon?.forEach(item=>{
           let obj :any = {};
           obj.linkTypeDescription = item.label;
           obj.description = item.hreflink;
           obj.svg = item.iconlink;
           tempArr.push(obj)
         })
         return tempArr
    }
    
    public async appendSocialLinks(links:  { linkTypeDescription: string; }[]): Promise<void> {
        const socialIcons = document.querySelector('.fb-social-block');
        const replaceLocalRaw = await this.getLocalSocialIcon();
        const replaceLocal = Array.isArray(replaceLocalRaw) ? replaceLocalRaw : [];
        
        const filteredNationalSocialicon = replaceLocal?.filter((obj1 : any) => !links?.some(obj2 => obj1.label.toLowerCase() === obj2.linkTypeDescription?.toLowerCase()));
        const filterdArray = this.formSocialLink(filteredNationalSocialicon);

        if(filterdArray && filterdArray.length > 0) {
            links.push(...filterdArray);
        }

            while (socialIcons?.firstChild) {
                socialIcons.removeChild(socialIcons.firstChild);
        }
        const iconList:any[] = [];
        links?.filter((item: any) => {
            const yelpRemove = item?.linkTypeDescription?.toLowerCase();
            const description = item?.description;
            const label = item?.linkTypeDescription;
            const svg = (item?.svg)??`<use xlink:href="/_assets-global/images/social-icon-sprite.svg#${label.toLowerCase()}" />`;
            if(yelpRemove != 'yelp'){
                iconList.push(
                    `<li class="fb-social-li">
                        <a href="${description}" target="_blank" rel="noopener" class="fb-social-link" aria-label="${label}">
                        <svg aria-hidden="true" class="social-icon">
                        ${svg}
                        </svg>
                        </a>
                    </li>`
                );
            }
        });
    
        socialIcons?.insertAdjacentHTML('beforeend', iconList.join(''));
        sessionStorage.setItem('socialIconsFooter', iconList.join(''));
        await handleSocialIcon(socialIcons);
        
    }

    public changeFooterAddress(data: address) {
        if(!ConditionalLocalization.getInstance().init()) return;
        const { locationDoingBusinessAs, address, address2, state, country, city, zip, displayAddressSwitch, stateLicenseNumbers } = data;
        let licenseNumber:any;
        if(stateLicenseNumbers?.length > 1){
            licenseNumber = this.getLicenseNumber(stateLicenseNumbers)
        }else {
            licenseNumber = stateLicenseNumbers ? stateLicenseNumbers[0] ? stateLicenseNumbers[0] : '' : ''
        }
        const addressContainer: any = document.querySelector('.fb-des-block-para');
        const ft = document.querySelectorAll('.local-address-footer')
        if (ft) {
            ft.forEach((x: any) => x.remove())
        }
        if(licenseNumber != ''){
            licenseNumber = licenseNumber[0] === '#' ? licenseNumber : '#'+licenseNumber;
        }
        let fullAddress = ''
        if (city && state && zip) {
            if(!displayAddressSwitch)
                fullAddress = `${city}, ${state}, ${zip}`;
            else
                fullAddress = `${address}${address2 ? ', '+ address2 : ''}, ${city}, ${state}, ${zip}`;
            showAddressForGoogle(fullAddress);
        }
        const addresData = `<div  class="local-address-footer"> 
                                    <p>${locationDoingBusinessAs}</p>
                                    ${displayAddressSwitch ? `
                                        <address class="address-line">
                                        <span>${address}${address2 ? ', ' + address2 : ''} </span>
                                        <span>${city}, ${state}, ${zip}</span>
                                       ${licenseNumber ? `<span>License: ${licenseNumber}</span>` : ''}
                                    </address>`: `
                                    <address class="address-line">
                                    <span>${city}, ${state}, ${zip}</span>
                                    ${licenseNumber ? `<span>License: ${licenseNumber}</span>` : ''}
                                </address>
                                    ` }
                                   
                                </div>`;
        if(addressContainer){
            addressContainer.insertAdjacentHTML('beforeend', addresData);
        }
        
    }


    public setMobileNumber(phoneNumber: string): HTMLAnchorElement | null {
        if(shouldSkipPhoneNumberProcessing())
            return null;
        const reg =  /(\d{0,3})(\d{0,3})(\d{0,4})/;
        const phoneFormat = String(phoneNumber).replace(/\D/g, '').match(reg);
        const mobNumber = document.querySelector('.fb-des-para > .fb-tel') as HTMLAnchorElement;

        if (phoneFormat && mobNumber) {
            mobNumber.innerHTML = `(${phoneFormat[1]}) ${phoneFormat[2]}-${phoneFormat[3]}`;
            mobNumber.href = `tel:${phoneFormat[1]}${phoneFormat[2]}${phoneFormat[3]}`;
        }
        return mobNumber;
    }

    private setServices(footerList: any) {



        const serviceSection = document.querySelector('#fblinkblock-services > .footer-submenu')

        while (serviceSection?.firstChild) {
            serviceSection.removeChild(serviceSection.firstChild);
        }

        if (footerList.length == 0 && document.getElementById('fblinkblock-services')) {
            document.getElementById('fblinkblock-services')!.style.display = 'none'

        }

        const listItem = footerList.map((item: any) => {
            return `<li class="submenu-li">
            <a href=${item.link} class="submenu-a">${item.name}</a>
             </li>`;
        });

        serviceSection?.insertAdjacentHTML('beforeend', listItem.join(''));
    }
    public getLicenseNumber(stateLicenseNumbers:any) {
        if(Array.isArray(stateLicenseNumbers)){
            return stateLicenseNumbers.map((item)=> {
               return item.includes('#') ? item : `#${item}`;
            }).join(', ' );
        }
    }
    async fetchCesUrl() {
        if(!ConditionalLocalization.getInstance().init()) return;
        const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
        
        const brandData = await getBrandDetailsFromBrandJson(conceptCode);
        if (brandData?.displayCESurl) {
            const franchiseWeblocationId: FullAttributeParams = localStorage.getItem("franchiseWebLocationId") as FullAttributeParams;

            const url = `${apiConfig.GET_ATTRIBUTE_DATA}/${franchiseWeblocationId}`;
            try {
                const resp: any = await cachedAPIWrapper(url, apiCaching.FullAttributeResponse);
                // DOMContentLoaded-based logic for DOM readiness
                if (document.readyState === "loading") {
                    document.addEventListener("DOMContentLoaded", () => {
                        const footerLink = document.querySelector(".footer-block .footer-url-link") as HTMLAnchorElement;
                        const footerBlock = document.querySelector(".footer-block .fb-des-block-para");
                        const localAddressFooter = document.querySelector(".footer-block .local-address-footer");
                        if (footerLink && footerBlock && localAddressFooter && resp.locationWebsiteUrl) {
                            footerLink.href = resp.locationWebsiteUrl;
                            footerLink.textContent = resp.locationWebsiteUrl.replace(/^https?:\/\/(www\.)?/, '');
                            footerBlock.insertBefore(footerLink, localAddressFooter.nextSibling);
                        }
                    });
                } else {
                    const footerLink = document.querySelector(".footer-block .footer-url-link") as HTMLAnchorElement;
                    const footerBlock = document.querySelector(".footer-block .fb-des-block-para");
                    const localAddressFooter = document.querySelector(".footer-block .local-address-footer");
                    if (footerLink && footerBlock && localAddressFooter && resp.locationWebsiteUrl) {
                        footerLink.href = resp.locationWebsiteUrl;
                        footerLink.textContent = resp.locationWebsiteUrl.replace(/^https?:\/\/(www\.)?/, '');
                        footerBlock.insertBefore(footerLink, localAddressFooter.nextSibling);  // Insert after local-address-footer
                    }
                }

            } catch (error) {
                console.error("Error in fecthing Full Attribute Details:", error);
            }
        }
    }

    /** Windsurf generated code start */
    private shouldSkipLocalization(dbaName: string | null, webId: string | null): boolean {
        return !webId || !dbaName || window.location.href.includes(dbaName);
    }

    private async loadBrandDataFallback(): Promise<void> {
        const brandDataReady = await waitForBrandDataBeforeFooterConfig();
        
        if (brandDataReady) {
            return;
        }

        const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
        const brandData = await getBrandDetailsFromBrandJson(conceptCode);
        
        if (brandData && isTestEnvironment()) {
            console.log('Brands.json loaded successfully as a fallback on 2nd attempt');
        }
    }

    private async fetchFooterConfig(): Promise<void> {
        const urlName = await getWeblocationPathGroupWithFooterConfig();
        const request = {
            method: 'GET',
            url: urlName
        };
        
        try {
            const response: any = await apiRequest(request);
            replaceLegalFooter(response);
        } catch (apiError: any) {
            this.logFooterConfigError(apiError);
        }
    }

    private logFooterConfigError(apiError: any): void {
        if (!isTestEnvironment()) {
            return;
        }

        console.error('Footer config API request failed:', apiError);
        
        if (apiError?.status === 404) {
            console.log('Local footer config not found');
        }
    }

    async localizeLegalFooter() {
        try {
            const dbaName: string | null = localStorage.getItem('dbaName');
            const webId: string | null = localStorage.getItem('weblocationId');
            
            if (this.shouldSkipLocalization(dbaName, webId)) {
                return;
            }

            await this.loadBrandDataFallback();
            await this.fetchFooterConfig();
        } catch (err) {
            console.error('Error in localizeLegalFooter:', err);
        }
    }
    /** Windsurf generated code end */
    
}

Footer.init();